export default Object.freeze({
  User: 1,
  System: 2,
  AnonymousUser: 3,
  RpaAgent: 4,
  ProcessEngine: 5,
  Webhook: 6,
});
